
/**
 * Classe responsável em manter o Menu Recente para aplicações no ambiente Cana.
 */
export class RecentsDTO {

    aplicativo: string;
    form: string;
    child: string;
    path: string;
    usuario: string;

}